import moment from 'moment'
import twitterText from 'twitter-text'

/**
 * 翻訳関数 (for script setup)
 */
/**
 * 日時をフォーマット
 */
export function formatDatetime(datetime: string): string | null {
  if (!datetime) {
    return null
  }
  const date = moment(datetime)
  if (!date.isValid()) {
    return null
  }
  return date.format('YYYY年MM月DD日 HH:mm')
}

/**
 * 日付をフォーマット
 */
export function formatDate(datetime: string): string | null {
  if (!datetime) {
    return null
  }
  const date = moment(datetime)
  if (!date.isValid()) {
    return null
  }
  return date.format('YYYY年MM月DD日')
}

/**
 * 時間をフォーマット
 */
export function formatTime(datetime: string): string {
  return moment(datetime).format('HH:mm')
}

/**
 * 年月をフォーマット
 */
export function formatYearMonth(datetime: string): string | null {
  const yearMonth = moment(datetime)
  if (!yearMonth.isValid()) {
    return null
  }
  return yearMonth.format('YYYY年MM月')
}

/**
 * 数字フォーマット
 */
export function formatNumber(value: string | number): string {
  return Number(value).toLocaleString()
}

/**
 * ポストテキストをフォーマット
 */
export function formatTweetText(text: string): string {
  return twitterText.autoLink(text, {
    usernameIncludeSymbol: true,
    extractUrlsWithoutProtocol: true,
    targetBlank: true
  } as any)
}
